import AddressLine from "@/app/features/assets/AddressLine";
import { SectionText } from "@/app/features/reports/components/section-text";
import { useReportContext } from '@/app/features/reports/contexts/report-context';
import ImageWithFallback from "@/components/raytd/image-with-fallback";
import { AssetEntity } from "@app.raytd.com/store";
interface InspectedAssetsSectionProps {
  assets: AssetEntity[];
}

export function InspectedAssetsSection({ assets }: InspectedAssetsSectionProps) {

  const { editMode } = useReportContext();

  return (
    <section className="mb-6 space-y-6" data-print-section="inspected-assets">
      <h2 className="font-medium text-lg">Inspected assets</h2>

      <SectionText position="introduction-before-inspected-assets" className="" />

      <div className="flex flex-wrap gap-20">
        {assets.map((asset) => (
          <AssetCard key={asset.id} asset={asset} editMode={editMode} />
        ))}
      </div>
    </section>
  )
}

interface AssetCardProps {
  asset: AssetEntity;
  editMode: boolean;
}

function AssetCard({ asset, editMode }: AssetCardProps) {

  if (!asset) {
    return null;
  }

  return (
    <div className="">

      <ImageWithFallback
        src={asset.imageUrl}
        alt={asset.name}
        className="w-24 h-24 object-cover rounded mb-4"
        fallbackSrc='/no_building.svg' />

      <h3 className="font-medium text-base">{asset.name}</h3>
      {/* <p className="text-sm text-muted-foreground">{asset.address?.street}</p> */}
      <AddressLine
        twoLines
        className="text-sm text-muted-foreground"
        address={asset.address}
        excludeCountry
      />
      {/* <p className="text-sm text-muted-foreground">{`${asset.address?.suburb ?? asset.address?.city}, ${asset.address?.state} ${asset.address?.postcode}`}</p> */}
    </div>
  )
}